import PosthogService from '~/services/posthog/PosthogService';

export interface IFeedbackSubmittedPayload {
  rating: number | null;
  ratingDescription: string | null;
  hasMessage: boolean;
}

/**
 * Fires when a user submits app feedback (emoji rating + optional note)
 * Event: office:feedback:submitted
 *
 * `rating` / `ratingDescription` are omitted when null so the payload matches
 * the previous hook-based path (which stripped null/undefined properties).
 */
export function fireFeedbackSubmitted(payload: IFeedbackSubmittedPayload): void {
  PosthogService.getInstance().track('office:feedback:submitted', {
    ...(payload.rating != null ? { rating: payload.rating } : {}),
    ...(payload.ratingDescription != null
      ? { ratingDescription: payload.ratingDescription }
      : {}),
    hasMessage: payload.hasMessage,
  });
}
